export const InvoiceToReceiptTag = {
	code: 'FP',
	description: 'FP - Faktura do paragonu'
};
